// extracted by mini-css-extract-plugin
export default {"blokicon":"Footer_blokicon__eU8Xp","bloktwitter":"Footer_bloktwitter__KZR7w","blokinstagram":"Footer_blokinstagram__TYZGA"};